export default "__VITE_ASSET__D5BxxGhG__"